import i18n, { type Resource, type ResourceLanguage } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enTranslations from "./locales/en.json";
import frTranslations from "./locales/fr.json";

type LocaleBundle = Record<string, unknown>;

const frBundle = frTranslations as LocaleBundle;
const enBundle = enTranslations as LocaleBundle;

const buildNamespaceResources = (bundle: LocaleBundle): ResourceLanguage => {
  const namespaces: ResourceLanguage = {
    translation: bundle,
  };

  Object.entries(bundle).forEach(([namespace, value]) => {
    if (typeof value === "object" && value !== null) {
      namespaces[namespace] = value as ResourceLanguage[string];
    }
  });

  return namespaces;
};

const resources: Resource = {
  en: buildNamespaceResources(enBundle),
  fr: buildNamespaceResources(frBundle),
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Let the detector pick from storage or browser; fallback to FR
    fallbackLng: "fr",
    debug: import.meta.env.DEV,

    detection: {
      order: ["localStorage", "querystring", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },

    initImmediate: false,

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
